<template>
  <div class="ly_modal_container" :style="{zIndex}">
    <div class="ly_modal_header" @mousedown="dragStart">
      <h1 class="title">소식톡톡 일반소식 등록</h1>
    </div>
    <div class="ly_modal_content" style="min-height: 472px; min-width: 837px">
      <div v-if="newsData" class="table_wrapper">
        <table class="table_view" style="width: 800px">
          <caption>
            <span class="blind">소식톡톡 일반소식 등록</span>
          </caption>
          <colgroup>
            <col width="120" />
            <col />
          </colgroup>
          <tbody class="table_view_body">
            <TargetSector
              :rcpGroupSendYn.sync="newsData.rcpGroupSendYn"
              :selectedRcpList.sync="selectedRcpList"
              :required="true"
              ref="targetSelector"
            />
            <TitleInput :boardTitle.sync="newsData.boardTitle" :required="true" ref="titleInput" />
            <ContentInput :boardContent.sync="newsData.boardContent" :required="true" ref="contentInput" />
            <SnoozeSelector
              :hasSnooze.sync="newsData.hasSnooze"
              :snoozeMax.sync="newsData.snoozeMax"
              :snoozeInterval.sync="newsData.snoozeInterval"
              ref="snoozeSelector"
            />
            <SendTimeSelector
              :pushType.sync="newsData.pushType"
              :reserveDate.sync="newsData.reserveDate"
              :required="true"
              ref="sendTimeSelector"
            />
          </tbody>
        </table>

        <div class="btn_area">
          <button type="button" class="btn_active" @click="submit">등록</button>
          <button type="button" class="btn_default" @click="close">닫기</button>
        </div>
      </div>
    </div>

    <button type="button" @click.prevent="close" class="ly_modal_close">
      <span class="ico">팝업 닫기</span>
    </button>
  </div>
</template>

<script>
import popupMixin from '$mixins/popup';
import newsMixin from '$views/News/_mixin';
import newsRegisterMixin, {defaultData} from './mixins/register';

import TargetSector from './inputs/TargetSelector';
import TitleInput from './inputs/TitleInput';
import ContentInput from './inputs/ContentInput';
import SnoozeSelector from './inputs/SnoozeSelector';
import SendTimeSelector from './inputs/SendTimeSelector';

export default {
  mixins: [popupMixin, newsMixin, newsRegisterMixin],
  props: {
    onSubmit: Function,
  },
  components: {
    TargetSector,
    TitleInput,
    ContentInput,
    SnoozeSelector,
    SendTimeSelector,
  },
  data() {
    return {
      newsData: _.merge({}, defaultData),
      selectedRcpList: [],
    };
  },
  methods: {
    submit() {
      if (!this.validate()) return false;
      const params = {
        newsType: 'NEWS',
        boardTitle: this.newsData.boardTitle,
        boardContent: this.newsData.boardContent,
        rcpGroupSendYn: this.newsData.rcpGroupSendYn,
      };
      if (params.rcpGroupSendYn === 'N') {
        params.rcpIdList = _.map(this.selectedRcpList, (item) => item.recipientId);
      } else {
        const groupData = this.$refs.targetSelector.getGroupData();
        params.orgCode = groupData.orgId;
        params.rcpState = groupData.stateId;
        params.addrCity = groupData.cityId;
        params.rcpGroup = groupData.groupId;
      }

      params.pushType = this.newsData.pushType;
      if (params.pushType === 'RESERVE') {
        params.reserveDate = this.$utils.timeText(this.newsData.reserveDate, true);
      }

      const {hasSnooze, snoozeMax, snoozeInterval} = this.newsData;
      Object.assign(params, {hasSnooze, snoozeMax, snoozeInterval});

      const messages = this.getSubmitMessagesGeneral();
      confirm(messages.confirm).then(() => {
        this.$axios.post('/admin/v2/news/general', params).then(() => this.onSubmitData(messages.complete));
      });
    },
    onSubmitData(msg) {
      alert(msg);
      if (this.onSubmit) this.onSubmit();
      this.close();
    },
    validate() {
      if (
        !this.$refs.targetSelector.validate() ||
        !this.$refs.titleInput.validate() ||
        !this.$refs.contentInput.validate() ||
        !this.$refs.snoozeSelector.validate() ||
        !this.$refs.sendTimeSelector.validate()
      )
        return false;

      return true;
    },
  },
};
</script>
